import main from '@/data/main.js'
export default class Quote{
    private base_url = `${main.BASE_ENDPOINT}/lms_agenda`

    public async GetQuote() {
        const uri = `${this.base_url}`
        const rawResponse = await fetch(uri, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        const response = await (rawResponse).json()
        return response
    }
      public async GetQuoteDetails(id:string | string[]) {
        const uri = `${this.base_url}/${id}`
        const rawResponse = await fetch(uri, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        const response = await (rawResponse).json()
        return response
    }
    public async AddQuote() {
        const uri = `${this.base_url}`
        const rawResponse = await fetch(uri, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        const response = await (rawResponse).json()
        return response
    }

}